import { cn } from "../../../lib/utils";
import { lpConfig } from "../lpConfig";
import { useFadeIn } from "../useFadeIn";

/**
 * オンボーディングフローセクション
 * 申し込みから運用開始までの5ステップを縦型タイムラインで表示する
 * @return {JSX.Element} オンボーディングセクションコンポーネント
 */
export function LpOnboarding() {
  const { ref, isVisible } = useFadeIn();

  return (
    <section className="py-24 lg:py-32 bg-gradient-to-b from-white to-gray-50">
      <div
        ref={ref}
        className={cn(
          "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lp-fade-in-up",
          isVisible && "lp-visible",
        )}
      >
        <div className="text-center">
          <p className="text-xs font-bold tracking-widest text-[#1667CF] uppercase mb-4">
            {lpConfig.onboarding.sectionLabel}
          </p>
          <h2 className="text-4xl font-bold text-[#0F1649] mb-4">
            {lpConfig.onboarding.heading}
          </h2>
          <p className="text-gray-500 mb-16">{lpConfig.onboarding.subtitle}</p>
        </div>

        <div className="max-w-2xl mx-auto relative">
          {/* Vertical line */}
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gray-200" />

          {lpConfig.onboarding.steps.map((step, index) => (
            <div
              key={step.day}
              className={cn(
                "relative pl-20",
                index < lpConfig.onboarding.steps.length - 1 ? "pb-12" : "pb-0",
              )}
            >
              {/* Day circle */}
              <div className="absolute left-4 w-8 h-8 rounded-full bg-[#02072F] text-white text-xs font-bold flex items-center justify-center">
                {step.day}
              </div>

              <div>
                <h3 className="text-xl font-bold text-[#0F1649] mb-1">
                  {step.title}
                </h3>
                <p className="text-gray-500">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
